<template>
  <div class="layout" style="width:100%;height:100%;" v-loading="loading">
    <router-view ref="child" />
    <login-new ref="login" title="登录后即可开通志愿卡服务" @logined="logined" />
  </div>
</template>
<script>
export default {
  name:'Layout',
  data(){
    return {
      loading: true
    }
  },
  computed: {
    loginInfo(){
      return this.$store.getters.loginInfo
    }
  },
  mounted() {
    this.setOrigin()
    this.closeLoading()
    this.setInviteCode()
  },
  methods: {
    setOrigin(){
      // 设置来源
      if(this.$route.query.gsrc){
        localStorage['gsrc'] = this.$route.query.gsrc
      } else if(this.$route.params.gsrc){
        localStorage['gsrc'] = this.$route.params.gsrc
      } else {
        localStorage['gsrc'] = undefined;
      }
    },
    setInviteCode(){
      if(this.$route.query.inviteCode){
        localStorage.setItem('zyInviteCode',this.$route.query.inviteCode)
      }
    },
    closeLoading(){
      window.onload = () => {
        this.loading = false
      }
      setTimeout(() => {
        this.loading = false
      },3000)
    },
    logined(isLogin){
      this.$refs['child'].logined(isLogin)
      if(isLogin){
        let link = location.origin +'/v/zy/index?inviteCode='+btoa(this.loginInfo.uid)
        this.$refs['child'].setShareInfo('',link)
      }
    }
  }
}
</script>